import { Box, Flex } from '@/components/atoms/Grid'
import { ProductRateData } from '@/network/graphql.g'
import { FC, useMemo } from 'react'
import styled from 'styled-components'
import { v4 as uuidv4 } from 'uuid'
import StarRatingDetailedRow from './starRatingDetailedRow'
import StarRatingOverall from './starRatingOverall'
import { validFor } from '@/theme/validFor'

type StarRatingProps = {
  productRateData: ProductRateData
}

const StarRatingContainer: FC<StarRatingProps> = ({ productRateData }) => {
  const { rateCounts, rateTotal } = productRateData ?? {}

  const starValues = Array.from({ length: 5 })
    .map((_, index) => index + 1)
    .reverse()
  const starValuesKeys = starValues.map(() => useMemo(() => uuidv4(), []))

  return (
    <StyledFlex
      my={{ mobile: 3, tablet: 3, desktop: 2 }}
      flexDirection={{
        mobile: 'column',
        tablet: 'column',
        desktop: 'row'
      }}
    >
      <StarRatingOverall rateCounts={rateCounts} rateTotal={rateTotal} />
      <StyledBox>
        {starValues.map((star, index) => (
          <StarRatingDetailedRow
            key={starValuesKeys[index]}
            productRateData={productRateData}
            star={star}
          />
        ))}
      </StyledBox>
    </StyledFlex>
  )
}

export default StarRatingContainer

const StyledFlex = styled(Flex)`
  max-width: 500px;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
`

const StyledBox = styled(Box)`
  ${validFor.mobile`
    width: 100%;
`};
  ${validFor.tablet`
    width: 100%;
`};
`
